const GitHubIcon = () => (
	<svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor" className="hover:text-amber-300">
		<path d="M12 0c-6.626 0-12 5.373-12 12 0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23.957-.266 1.983-.399 3.003-.404 1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v 3.293c0 .319.192.694.801.576 4.765-1.589 8.199-6.086 8.199-11.386 0-6.627-5.373-12-12-12z"/>
	</svg>
);



const LinkedInIcon = () => (
	<svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor" className="hover:text-amber-300">
		<path d="M20.447 20.452h-3.554v-5.569c0-1.328-.475-2.236-1.986-2.236-1.081 0-1.722.731-2.004 1.431-.103.25-.129.599-.129.948v5.426h-3.555V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.225 0z"/>
	</svg>
);

const HeartIcon = () => (
	<svg className="h-4 w-4 text-amber-300" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
		<path d="M12 21s-7-4.4-9.5-8C.5 10.2 1.3 6.8 4.5 5.5c2.1-.8 4.3 0 5.5 1.8 1.2-1.8 3.4-2.6 5.5-1.8 3.2 1.3 4 4.7 2 7.5C19 16.6 12 21 12 21z" />
	</svg>
);

const ArrowRightIcon = () => (
	<svg className="h-4 w-4 inline-block" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
		<path d="M5 12h14" />
		<path d="m13 6 6 6-6 6" />
	</svg>
);

const Footer = () => {
	return (
		<footer className="w-full border-t border-slate-700 bg-gradient-to-b from-transparent via-slate-900/30 to-slate-950 py-8 px-4 md:pl-80 lg:pl-80">
			<div className="max-w-6xl mx-auto space-y-6">
				{/* Main Footer Content */}
				<div className="grid grid-cols-1 md:grid-cols-3 gap-8">
					{/* About */}
					<div className="space-y-2">
						<h3 className="font-semibold text-slate-100">About</h3>
						<p className="text-sm text-slate-400 leading-relaxed">
							Framework-agnostic component library built with pure HTML and Tailwind CSS. Zero dependencies, 100% customizable.
						</p>
					</div>

					{/* Quick Links */}
					<div className="space-y-2">
						<h3 className="font-semibold text-slate-100">Resources</h3>
						<ul className="space-y-1 text-sm">
							{[
									{ label: "GitHub", href: "https://github.com/metatech-programmer" },
									{ label: "Tailwind CSS", href: "https://tailwindcss.com" },
									{ label: "Accessibility", href: "/PagesResources" },
								].map(link => (
									<li key={link.label}>
										<a 
											href={link.href}
											target={link.href && link.href.startsWith("http") ? "_blank" : undefined}
											rel={link.href && link.href.startsWith("http") ? "noopener noreferrer" : undefined}
											className="text-amber-400 hover:text-amber-300 transition-colors duration-250"
										>
											<span className="inline-flex items-center gap-1">{link.label} <ArrowRightIcon /></span>
										</a>
									</li>
								))}
						</ul>
					</div>

					{/* Social */}
					<div className="space-y-2">
						<h3 className="font-semibold text-slate-100">Connect</h3>
								<div className="flex gap-4 text-amber-400 transition-colors duration-250">
							<a 
								href="https://github.com/metatech-programmer"
								target="_blank"
								rel="noopener noreferrer"
								aria-label="GitHub"
								className="text-amber-400 hover:text-amber-300 transition-transform duration-250 hover:scale-110"
								title="GitHub"
							>
								<GitHubIcon />
							</a>
							
							<a 
								href="https://www.linkedin.com/in/santiagoaguilartorres-fullstack/"
								target="_blank"
								rel="noopener noreferrer"
								aria-label="LinkedIn"
								className="text-amber-400 hover:text-amber-300 transition-transform duration-250 hover:scale-110"
								title="LinkedIn"
							>
								<LinkedInIcon />
							</a>
						</div>
					</div>
				</div>

				{/* Copyright */}
				<div className="border-t border-slate-700 pt-6 text-center text-sm text-slate-500 space-y-1">
					<p className="inline-flex items-center justify-center gap-1">
						Built with <HeartIcon /> by{" "}
						<a 
							href="https://santiagotorres-web-developer.netlify.app/"
							target="_blank"
							rel="noopener noreferrer"
									className="text-amber-400 hover:text-amber-300 transition-colors"
						>
							Metatech
						</a>
					</p>
					<p>© 2026 Metatech Components. All rights reserved.</p>
				</div>
			</div>
		</footer>
	);
};

export default Footer;


